"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOKEN_COOKIE_KEY = exports.SESSION_TOKEN_KEY = exports.SCOPE_ID_COOKIE_KEY = exports.LOGOUT_EVENT_KEY = exports.INFO_COOKIE_KEY = void 0;
exports.broadcastPortalLogout = broadcastPortalLogout;
exports.clearPortalAuthCookies = clearPortalAuthCookies;
exports.clearPortalLocalData = clearPortalLocalData;
exports.getPortalInfo = getPortalInfo;
exports.listenPortalLogout = listenPortalLogout;
exports.menuListStorageKey = menuListStorageKey;
exports.oneLvRoutesStorageKey = oneLvRoutesStorageKey;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _portalContext = require("@/utils/portalContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var TOKEN_COOKIE_KEY = exports.TOKEN_COOKIE_KEY = _portalContext.isSupplierPortal ? 'Java-supplierToken' : 'Java-merchantToken';
var INFO_COOKIE_KEY = exports.INFO_COOKIE_KEY = _portalContext.isSupplierPortal ? 'JavaSupplierInfo' : 'JavaMerInfo';
var SCOPE_ID_COOKIE_KEY = exports.SCOPE_ID_COOKIE_KEY = _portalContext.isSupplierPortal ? 'JavaSupplierId' : 'JavaMerchantId';
var SESSION_TOKEN_KEY = exports.SESSION_TOKEN_KEY = "mer_admin_session_token_".concat(_portalContext.portalType);
var LOGOUT_EVENT_KEY = exports.LOGOUT_EVENT_KEY = "MerMerAdmin:logout:".concat(_portalContext.portalType);
function menuListStorageKey() {
  return "MerMerAdmin_MenuList_".concat(_portalContext.portalType);
}
function oneLvRoutesStorageKey() {
  return "MerMerAdmin_oneLvRoutes_".concat(_portalContext.portalType);
}
function getPortalInfo() {
  var raw = _jsCookie.default.get(INFO_COOKIE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}
function broadcastPortalLogout() {
  localStorage.setItem(LOGOUT_EVENT_KEY, String(Date.now()));
}
function listenPortalLogout(handler) {
  window.addEventListener('storage', function (e) {
    if (e.key === LOGOUT_EVENT_KEY && e.newValue) {
      handler();
    }
  });
}
function clearPortalAuthCookies() {
  _jsCookie.default.remove(TOKEN_COOKIE_KEY);
  _jsCookie.default.remove(INFO_COOKIE_KEY);
  _jsCookie.default.remove(SCOPE_ID_COOKIE_KEY);
}
function clearPortalLocalData() {
  sessionStorage.removeItem(SESSION_TOKEN_KEY);
  localStorage.removeItem(menuListStorageKey());
  localStorage.removeItem(oneLvRoutesStorageKey());
}